var render = function render(){var _vm=this,_c=_vm._self._c;return _c('admin-wrapper',{attrs:{"straight-title":_vm.additionalModuleName,"module-enabler":_vm.moduleEnabler,"inputs":_vm.inputs}})
}
var staticRenderFns = []

export { render, staticRenderFns }